import React from 'react';
import { XIcon, ClipboardListIcon, TrashIcon } from 'lucide-react';
interface ShoppingCartProps {
  items: Array<{
    id: string;
    name: string;
    price: number;
    category: string;
  }>;
  onClose: () => void;
  onRemoveItem: (item: {
    id: string;
    name: string;
    price: number;
    category: string;
  }) => void;
}
export const ShoppingCart = ({
  items,
  onClose,
  onRemoveItem
}: ShoppingCartProps) => {
  const totalPrice = items.reduce((sum, item) => sum + item.price, 0);
  return <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" data-id="element-108">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full max-h-[90vh] overflow-auto" data-id="element-109">
        <div className="flex justify-between items-center p-4 border-b border-gray-200" data-id="element-110">
          <div className="flex items-center gap-2" data-id="element-111">
            <ClipboardListIcon size={20} data-id="element-112" />
            <h2 className="text-xl font-semibold" data-id="element-113">Pakkumise valikud</h2>
          </div>
          <button onClick={onClose} className="p-1 hover:bg-gray-100 rounded-full transition-colors" data-id="element-114">
            <XIcon size={20} data-id="element-115" />
          </button>
        </div>
        <div className="p-4" data-id="element-116">
          {items.length === 0 ? <div className="text-center py-8 text-gray-500" data-id="element-117">
              Pakkumisse pole lisatud ühtegi valikut
            </div> : <div className="space-y-4" data-id="element-118">
              {items.map((item, index) => <div key={`${item.category}-${item.id}`} className={`flex justify-between items-center p-3 rounded-md ${item.category === 'apartment' ? 'bg-orange-50' : 'bg-gray-50'}`} data-id="element-119">
                  <div data-id="element-120">
                    <div className="font-medium" data-id="element-121">{item.name}</div>
                    <div className="text-orange-500 font-semibold" data-id="element-122">
                      {item.price.toLocaleString()} €
                    </div>
                  </div>
                  {item.category !== 'apartment' && <button onClick={() => onRemoveItem(item)} className="p-1.5 hover:bg-gray-200 rounded-full transition-colors text-gray-600" title="Eemalda" data-id="element-123">
                      <TrashIcon size={16} data-id="element-124" />
                    </button>}
                </div>)}
              <div className="border-t border-gray-200 pt-4 mt-4" data-id="element-125">
                <div className="flex justify-between items-center" data-id="element-126">
                  <span className="font-medium" data-id="element-127">Kokku:</span>
                  <span className="text-xl font-bold text-orange-500" data-id="element-128">
                    {totalPrice.toLocaleString()} €
                  </span>
                </div>
              </div>
            </div>}
        </div>
      </div>
    </div>;
};